import { FieldViewModel, IPcnAnalysis } from "../../omnia"
import { IDataLayer, ISoilService } from "../../types"
import { AnalysisVM, createFieldAnalysis, createZoneAnalysis } from "../analysis-vm"

export class PcnAnalysisVM extends AnalysisVM<IPcnAnalysis> {

    public static create(svc: ISoilService, layers: IDataLayer[], field: FieldViewModel, selectedZoneId: number, currentView: boolean) {

        let analysis = svc.getPcnAnalysis();

        let fields = createFieldAnalysis(
            analysis,
            field,
            a => new PcnAnalysisVM(a),
            selectedZoneId,
            currentView);

        let zones = createZoneAnalysis(
            analysis,
            field,
            svc.yearId,
            layers,
            (analysis, layer, zone) => new PcnAnalysisVM(analysis, layer, zone),
            selectedZoneId,
            currentView);

        return fields.concat(zones);

    }

}
